module.exports = __webpack_public_path__ + "static/media/bfile-boat.e0d8f12d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/WizardInvitee/parts/images/bfile-boat.svg
// module id = 552
// module chunks = 0